import { authenticationConstants } from '../_constants/authentication.constants';

let token = JSON.parse(localStorage.getItem('token'));
const initialState = token ? { loggedIn: true, token, user: null } : {};

export function authentication(state = initialState, action) {  
  switch (action.type) {
    case authenticationConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        token: action.token
      };
    case authenticationConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        token: action.token
      };
    case authenticationConstants.LOGIN_FAILURE:
      return {};

    case authenticationConstants.GET_CURRENT_SUCCESS:
      return {
        loggedIn: true,
        token: state.token,
        user: action.user
      };
    case authenticationConstants.GET_CURRENT_FAILURE:
      localStorage.removeItem('token');
      return {};

    case authenticationConstants.LOGOUT:
      return {};

    default:
      return state
  }
}